<script setup>
import ProjectCardPreview from '@components/index/ProjectCardPreview.vue'
const props = defineProps(['i', 'project', 'active'])
</script>

<template>
	<router-link class="md?gap-1 group relative flex w-full flex-row items-center justify-between gap-5 overflow-hidden border-t border-crowns-off-white py-3 transition-all duration-300 md:justify-center lg:gap-3 lg:py-0 xl:py-2 3xl:py-4" :to="{ name: 'project', params: { slug: project.slug } }">
		<div class="left-0 flex font-cabazon text-xl transition-all duration-200 sm:text-2xl md:absolute lg:group-hover:-left-6">0{{ i }}</div>

		<div class="flex flex-grow flex-wrap items-center gap-1 md:flex-grow-0 md:gap-1.5">
			<div class="label">{{ project.name_split_1 }}</div>

			<div class="hidden w-20 transition-all duration-300 md:flex md:w-28 lg:w-0 lg:group-hover:w-40 3xl:group-hover:w-48" :key="project.slug">
				<ProjectCardPreview :project="project" :type="i" />
			</div>

			<div class="label">{{ project.name_split_2 }}</div>
		</div>

		<div class="flex w-36 min-w-36 max-w-36 justify-end sm:w-56 sm:min-w-56 md:hidden">
			<ProjectCardPreview :project="project" :type="i" />
		</div>
	</router-link>
	<!-- <transition name="fade" mode="out-in"></transition> -->
</template>

<style scoped>
.label {
	@apply flex items-center font-alternate-gothic text-[1.6rem] uppercase leading-none sm:text-4xl sm:text-[2.75rem] lg:h-28 lg:text-6xl xl:text-7xl 3xl:text-8xl;
}
</style>
